export enum LoadingStatus {
	ERROR = 'ERROR',
	NEVER = 'NEVER',
	LOADED = 'LOADED',
	SUCCESS = 'SUCCESS',
	LOADING = 'LOADING',
}
